import { Container } from "@react-email/components";

export default function DefaultContainer({ children }: { children: React.ReactNode }) {
  return (
    <Container className="bg-white w-full h-full max-w-[800px] xl:rounded-md xl:shadow-md px-[8px] py-[32px] xl:my-[32px] xl:px-[32px] xl:py-[32px]">{children}</Container>
  )
}